import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/conversation/$conversationId')({
  loader: ({ context: { auth } }) => {
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/'
      });
    }
  }
});
